import { useEffect } from 'react';
export function DisplayStyleListener({
  displayStyle,
  expandStatus,
  isActive,
  toggleExpandStatus
}) {
  useEffect(function toggleExpandOnDisplayStyleChange() {
    let timeout;
    window.clearTimeout(timeout);

    if (displayStyle === 'collapsed' && expandStatus !== 'collapsed') {
      toggleExpandStatus();
      return;
    }

    if (displayStyle === 'expanded' && isActive && expandStatus === 'collapsed') {
      timeout = window.setTimeout(toggleExpandStatus, 150);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [displayStyle]);
  return null;
}